import {useDispatch, useSelector} from 'react-redux';
import {setSearchValueDataGrid} from 'src/domain/app/redux/data-grid/data-grid-slice';
import Button from '../../button';
import {useNavigate} from 'react-router-dom';
import IntlMessages from 'src/domain/utility/IntlMessages';
import {AiOutlinePlus, AiOutlineSearch} from 'react-icons/ai';
import {useIntl} from 'react-intl';
import {
  getAddUrlDataGrid,
  getLabeAddButtonDataGrid,
  getSearchPlaceholderDataGrid,
  getShowSearchFieldDataGrid,
} from 'src/domain/app/redux/data-grid/data-grid-selectors';
import {ReactNode} from 'react';
import {Input} from '../../input';
import '../style.less';

interface IOptionsDataGridProps {
  optionChildren?: ReactNode;
}

const OptionsDataGrid: React.FC<IOptionsDataGridProps> = (props) => {
  const {optionChildren} = props;
  const {messages} = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showSearchField = useSelector(getShowSearchFieldDataGrid);
  const searchPlaceholder = useSelector(getSearchPlaceholderDataGrid);
  const labelAddButton = useSelector(getLabeAddButtonDataGrid);
  const addUrl = useSelector(getAddUrlDataGrid);

  return (
    <div className='dg-toolbar'>
      <div className='dg-toolbar-filters'>
        {showSearchField && (
          <Input
            allowClear
            background='white'
            placeholder={messages[
              `${searchPlaceholder ?? 'common.search'}`
            ].toString()}
            prefix={<AiOutlineSearch />}
            onChange={(event) => {
              setTimeout(() => {
                dispatch(setSearchValueDataGrid(event.target.value));
              }, 1200);
            }}
          />
        )}
        {optionChildren}
      </div>

      {labelAddButton && (
        <Button
          type='primary'
          icon={<AiOutlinePlus />}
          onClick={() => addUrl && navigate(addUrl)}>
          <IntlMessages id={labelAddButton} />
        </Button>
      )}
    </div>
  );
};

export default OptionsDataGrid;
